import React, { useState } from 'react';

const TestButton = () => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    console.log('Test button clicked!');
    setClicked(true);
    alert('Test button works!');
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Button Test Page</h1>
      <p>This is a minimal test to isolate button functionality.</p>
      
      <div style={{ margin: '20px 0' }}>
        <button 
          type="button"
          onClick={handleClick}
          style={{ 
            padding: '10px 20px', 
            fontSize: '16px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          {clicked ? 'Button Clicked!' : 'Test Button'}
        </button>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Debug Info:</h3>
        <p>Clicked: {clicked ? 'Yes' : 'No'}</p>
        <p>Time: {new Date().toLocaleTimeString()}</p>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Test Instructions:</h3>
        <ol>
          <li>Click the button above</li>
          <li>Check if console shows "Test button clicked!"</li>
          <li>Check if alert appears</li>
          <li>Check if button text changes</li>
        </ol>
      </div>
    </div>
  );
};

export default TestButton;
